import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import dayjs from "dayjs";

export default class DailySalesProgressResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                daily_sales_progress: [
                    {
                        date: "01-05-2026",
                        invoiced: "300000.00",
                        orders: null,
                        budget: "9000000.00",
                        prorated_budget: "290000.00",
                        invoiced_boxes: "71.00",
                        orders_boxes: null,
                        budget_boxes: "2140.00",
                        prorated_budget_boxes: "69.00",
                    },
                ],
            },
            errors: [],
        };
    }

    dailySalesProgress() {
        return this.content().daily_sales_progress.map((entry) => ({
            date: dayjs(entry.date, "DD-MM-YYYY"),
            invoiced: this._toNumber(entry.invoiced),
            orders: this._toNumber(entry.orders),
            budget: this._toNumber(entry.budget),
            proratedBudget: this._toNumber(entry.prorated_budget),
            invoicedBoxes: this._toNumber(entry.invoiced_boxes),
            ordersBoxes: this._toNumber(entry.orders_boxes),
            budgetBoxes: this._toNumber(entry.budget_boxes),
            proratedBudgetBoxes: this._toNumber(entry.prorated_budget_boxes),
        }));
    }

    _toNumber(value) {
        return value == null ? null : Number(value);
    }
}
